module.exports = __webpack_public_path__ + "static/media/burger.c2d14d7f.svg";